import axios from 'axios';
import { API_URL } from '../constants/config';

// Общий axios-инстанс для всех запросов к API.
// Через него работают два механизма поддержания сессии:
// 1. Скользящее продление — сервер кладёт свежий JWT в заголовок X-New-Token,
//    мы сохраняем его и уведомляем AuthContext (событие auth:token-refreshed).
// 2. Авто-logout — если сервер ответил 401 с code: 'SESSION_EXPIRED'
//    (истёкший/отозванный токен), чистим сессию и уведомляем AuthContext
//    (событие auth:session-expired) — ProtectedRoute уведёт на /login.
//    Прочие 401 (неверный пароль при входе/смене) не трогают сессию.
const http = axios.create({ baseURL: API_URL });

export const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

http.interceptors.response.use(
  (response) => {
    const newToken = response.headers['x-new-token'];
    if (newToken) {
      localStorage.setItem('token', newToken);
      window.dispatchEvent(new CustomEvent('auth:token-refreshed', { detail: newToken }));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && error.response.data?.code === 'SESSION_EXPIRED') {
      localStorage.removeItem('token');
      localStorage.removeItem('authUser');
      window.dispatchEvent(new Event('auth:session-expired'));
    }
    return Promise.reject(error);
  }
);

export default http;
